let scriptPromise = null

const SCRIPT_ID = 'cf-turnstile-script'

export function loadTurnstileScript () {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile)
  }

  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const existing = document.getElementById(SCRIPT_ID)

      if (existing) {
        existing.addEventListener('load', () => resolve(window.turnstile))
        existing.addEventListener('error', () =>
          reject(new Error('Failed to load Cloudflare Turnstile')))
        return
      }

      const script = document.createElement('script')

      script.id = SCRIPT_ID
      script.src =
        'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
      script.async = true
      script.defer = true
      script.addEventListener('load', () => resolve(window.turnstile))
      script.addEventListener('error', () =>
        reject(new Error('Failed to load Cloudflare Turnstile')))

      document.head.appendChild(script)
    })
  }

  return scriptPromise
}
